var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emap-flow-toolbar" }, [
    _c(
      "div",
      { staticClass: "emap-flow-buttons" },
      _vm._l(_vm.buttons, function (item, index) {
        return _c(
          "Button",
          {
            key: item.id,
            ref: item.id,
            refInFor: true,
            staticClass: "flow-button",
            class: [item.className],
            attrs: {
              type: item.buttonType
                ? item.buttonType
                : _vm.specialBtn.indexOf(item.commandType) > -1
                ? "primary"
                : "default",
              disabled: item.disabled,
            },
            on: {
              click: function ($event) {
                return _vm.btnClickHandler(item, index)
              },
            },
          },
          [_vm._v(_vm._s(item.name))]
        )
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "emap-flow-modal" },
      [
        _vm.cur_btn.commandType === "changeAssignee"
          ? _c("change-assignee", {
              attrs: {
                options: _vm.cur_btn,
                taskid: _vm.taskid,
                defkey: _vm.defkey,
              },
              on: { "on-confirm": _vm.changeAssigneeConfirm },
              model: {
                value: _vm.showpickForTransfer,
                callback: function ($$v) {
                  _vm.showpickForTransfer = $$v
                },
                expression: "showpickForTransfer",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_btn.commandType === "distributeSubmit"
          ? _c("hand-out", {
              attrs: { options: _vm.cur_btn },
              on: { "on-confirm": _vm.distributeConfirm },
              model: {
                value: _vm.distributeModal,
                callback: function ($$v) {
                  _vm.distributeModal = $$v
                },
                expression: "distributeModal",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.buttonsId.indexOf("urgent") > -1
          ? _c(
              "div",
              { staticClass: "emap-flow-modal-urgent" },
              [
                _c(
                  "Modal",
                  {
                    attrs: { title: _vm.$LocalH5("toolbar.urgingMessage") },
                    model: {
                      value: _vm.urgentModal,
                      callback: function ($$v) {
                        _vm.urgentModal = $$v
                      },
                      expression: "urgentModal",
                    },
                  },
                  [
                    _c(
                      "Form",
                      {
                        ref: "urgentForm",
                        attrs: {
                          model: _vm.urgentForm,
                          rules: _vm.urgentRules,
                          "label-width": 80,
                        },
                      },
                      [
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: _vm.$LocalH5("title"),
                              prop: "subject",
                            },
                          },
                          [
                            _c("Input", {
                              model: {
                                value: _vm.urgentForm.subject,
                                callback: function ($$v) {
                                  _vm.$set(_vm.urgentForm, "subject", $$v)
                                },
                                expression: "urgentForm.subject",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: _vm.$LocalH5("content"),
                              prop: "content",
                            },
                          },
                          [
                            _c("Input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.urgentForm.content,
                                callback: function ($$v) {
                                  _vm.$set(_vm.urgentForm, "content", $$v)
                                },
                                expression: "urgentForm.content",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "FormItem",
                          {
                            attrs: {
                              label: _vm.$LocalH5("toolbar.msgType"),
                              prop: "sendType",
                            },
                          },
                          [
                            _c(
                              "CheckboxGroup",
                              {
                                model: {
                                  value: _vm.urgentForm.sendType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.urgentForm, "sendType", $$v)
                                  },
                                  expression: "urgentForm.sendType",
                                },
                              },
                              _vm._l(_vm.sendType, function (item) {
                                return _c(
                                  "Checkbox",
                                  {
                                    key: item.value,
                                    attrs: { label: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "footer" }, slot: "footer" },
                      [
                        _c(
                          "Button",
                          {
                            attrs: { size: "large" },
                            on: {
                              click: function ($event) {
                                _vm.urgentModal = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary", size: "large" },
                            on: { click: _vm.urgentConfirm },
                          },
                          [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.spinShow
                      ? _c("Spin", { attrs: { size: "large", fix: "" } })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_btn.commandType === "addAssigneeTask"
          ? _c("add-assignee", {
              attrs: { taskid: _vm.taskid, defkey: _vm.defkey },
              on: { "on-confirm": _vm.addAssigneeConfirm },
              model: {
                value: _vm.addAssigneeModal,
                callback: function ($$v) {
                  _vm.addAssigneeModal = $$v
                },
                expression: "addAssigneeModal",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_btn.commandType === "deleteAssigneeTask"
          ? _c("del-assignee", {
              attrs: { taskid: _vm.taskid, defkey: _vm.defkey },
              on: { "on-confirm": _vm.delAssigneeConfirm },
              model: {
                value: _vm.delAssigneeModal,
                callback: function ($$v) {
                  _vm.delAssigneeModal = $$v
                },
                expression: "delAssigneeModal",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.buttonsId.indexOf("processTrack") > -1
          ? _c(
              "div",
              { staticClass: "emap-flow-modal-processTrack" },
              [
                _c(
                  "Modal",
                  {
                    staticClass: "emap-flow-modal-processTrack",
                    attrs: {
                      title: _vm.$LocalH5("toolbar.processTrack"),
                      "mask-closable": false,
                      transfer: false,
                      width: "600",
                    },
                    model: {
                      value: _vm.processTrackModal,
                      callback: function ($$v) {
                        _vm.processTrackModal = $$v
                      },
                      expression: "processTrackModal",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "scroll-content",
                        staticStyle: { width: "100%", overflow: "auto" },
                      },
                      [
                        _c(
                          "div",
                          {
                            ref: "js-canvas",
                            staticStyle: { position: "relative" },
                            attrs: { id: "js-canvas" },
                          },
                          [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                _vm._s(_vm.$LocalH5("toolbar.processTrackTips"))
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_btn.commandType === "turnback"
          ? _c(
              "div",
              { staticClass: "emap-flow-modal-turnback" },
              [
                _c(
                  "Modal",
                  {
                    attrs: {
                      title: _vm.$LocalH5("toolbar.goBack"),
                      "mask-closable": false,
                    },
                    model: {
                      value: _vm.backModal,
                      callback: function ($$v) {
                        _vm.backModal = $$v
                      },
                      expression: "backModal",
                    },
                  },
                  [
                    _c("emap-flow-next-step", {
                      ref: "nextstep",
                      attrs: {
                        taskId: _vm.taskid,
                        nodeurl: _vm.turnbackObj[_vm.cur_btn.backTo + "Node"],
                        assigneeurl:
                          _vm.turnbackObj[_vm.cur_btn.backTo + "Assignee"],
                        schema: "simple",
                        showNextNode: "",
                        echostyle: "id",
                        nodelabel: _vm.turnbackObj.nodelabel,
                        assigneeslabel: _vm.turnbackObj.assigneeslabel,
                        onnodeverify: _vm.turnbackNodeResponse,
                      },
                      model: {
                        value: _vm.turnbackValue,
                        callback: function ($$v) {
                          _vm.turnbackValue = $$v
                        },
                        expression: "turnbackValue",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "footer" }, slot: "footer" },
                      [
                        _c(
                          "Button",
                          {
                            attrs: { size: "large" },
                            on: {
                              click: function ($event) {
                                _vm.backModal = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary", size: "large" },
                            on: { click: _vm.backConfirm },
                          },
                          [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.formsubmit
      ? _c(
          "div",
          {
            staticStyle: { display: "none" },
            attrs: { id: "multipart-uploader" },
          },
          [
            _c("iframe", {
              attrs: { name: "upload_pipe", id: "upload_pipe", title: "上传" },
            }),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "multipart_form",
                attrs: {
                  action: _vm.formsubmiturl,
                  enctype: "multipart/form-data",
                  method: "POST",
                  target: "upload_pipe",
                },
              },
              [
                _c("input", {
                  ref: "multipart_data",
                  attrs: { type: "hidden", name: "data" },
                }),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }